import React from 'react';
import PropTypes from 'prop-types';
import { imagePrettyUrl, getImageFilename, getAltText } from 'gatsby-core-theme/src/helpers/getters';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import keygen from 'gatsby-core-theme/src/helpers/keygen';
import Link from 'gatsby-core-theme/src/hooks/link';
import useTranslate from '~hooks/useTranslate/useTranslate';
import CloseIcon from '~images/icons/close';
import styles from './notification-items.module.scss';

const NotificationItems = ({ module, onClose }) => {
    const { items } = module;
    const noNewUpdates = useTranslate('noNewUpdates', 'No new items')
    const content = (item) => {
        const img = item?.image;
        const imageSrc = imagePrettyUrl(img, 40, 40);
        const fileName = getImageFilename(imageSrc);
        const TitleTag = item?.title_tag || 'label';
        const ribbon = item?.subtitle?.split(',')[0].replace('[null]', '');
        const otherText = item?.subtitle?.split(',').slice(1);

        return (
            <div className={styles.notificationContent}>
                {img && (
                <LazyImage
                    width={40}
                    height={40}
                    alt={getAltText(item?.image_object, item?.label || item?.link_text || fileName)}
                    src={imageSrc}
                />
                )}
                {item?.label && <TitleTag>{item?.label}</TitleTag>}
                {item?.text && (
                <div className={styles.subtitle} dangerouslySetInnerHTML={{ __html: item?.text }} />
                )}
                {item?.subtitle && (
                <div className={styles.ribbonAndTime}>
                    {ribbon && <span className={styles.ribbon}>{ribbon}</span>}
                    <span className={styles.extraContent}>{otherText}</span>
                </div>
                )}
            </div>
        );
    };
    return (
        <div className={styles.container || ''}>
            <div className={styles.notificationsContainer || ''}>
                <span>
                    {useTranslate('latestUpdates', 'Latest Updates')}
                    <button 
                        type='button' 
                        onClick={onClose} 
                        className={styles.close || ''}
                        aria-label="Close notifications"
                    >
                        <CloseIcon />
                    </button>
                </span>
                {items?.length ? (
                <ul className={styles.notifications || ''}>
                    {items.map((item) => (
                    <li className={`${styles.notification} notification-item-gtm`} key={keygen()}>
                        {item?.link &&
                        (item?.link?.type === 'external' ? (
                            <a
                            href={item?.link?.value}
                            className="spotlights-gtm"
                            title={item?.label}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={`${item?.label || item?.link_text} Link`}
                            >
                            {content(item)}
                            </a>
                        ) : (
                            <Link
                            to={item?.link?.value}
                            title={item?.label}
                            className="spotlights-gtm"
                            aria-label={`${item?.label || item?.link_text} Link`}
                            >
                            {content(item)}
                            </Link>
                        ))}
                    </li>
                    ))}
                </ul>
                ) : (
                <>{noNewUpdates}</>
                )}
            </div>
            <div className={styles.triangle} />
            <div 
                className={styles.overlay} 
                onKeyDown={onClose}
                onClick={onClose}
                role="button"
                aria-label="Notification Bell Icon"
                tabIndex={0}
            />
        </div>
    );
};

NotificationItems.propTypes = {
    module: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    onClose: PropTypes.func
};

export default NotificationItems;
